import { AbstractClient, CompositionClient } from "@/app/client";
import * as types from "@/app/types";
import { UUID } from "crypto";
import APIUserSub from "./user/client";

export default class APIOffers extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  user = new APIUserSub(this._client);

  getOfferId = async (offerId: UUID): Promise<types.OfferResponse> => {
    let res = await this._fetch({
      url: `/offers/${offerId}`,
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  deleteOfferId = async (offerId: UUID): Promise<types.OfferResponse> => {
    let res = await this._fetch({
      url: `/offers/${offerId}`,
      method: "DELETE",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  putOfferId = async (
    offerId: UUID,
    { ...body }: types.OfferRequest,
  ): Promise<types.OfferResponse> => {
    let res = await this._fetch({
      url: `/offers/${offerId}`,
      method: "PUT",
      body: body,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
